import { render } from "./OwnerActions.vue?vue&type=template&id=b58dbd62"
import script from "./OwnerActions.vue?vue&type=script&lang=js"
export * from "./OwnerActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__